<template>
  <div class="site-footer" :style="{ height: ownHeight }">
    <footer ref="footerContent" :style="translateString">
      <div class="site-footer__header">
        <h1 class="site-footer__title">
          Have a project in mind?
          <br />feel free to reach out...
        </h1>
        <p
          class="site-footer__paragraph"
        >We are always happy to discuss any idea or project or other ways we can assist you. Just drop us a line or give us a call.</p>
      </div>
      <div class="site-footer__content">
        <div class="site-footer__contacts">
          <div class="site-footer__item">
            <h2 class="site-footer__item__title">Contact</h2>
            <a :href="`tel:${contacts.phone}`">{{contacts.phone}}</a>
            <br />
            <a :href="`mailto:${contacts.mail}`">{{contacts.mail}}</a>
          </div>
          <div class="site-footer__item">
            <h2 class="site-footer__item__title">Address</h2>
            <p>Njalsgade 21E, 1</p>
            <p>2300 København S</p>
          </div>
          <div class="site-footer__item">
            <h2 class="site-footer__item__title">Bank info</h2>
            <p>CVR: 30530748</p>
            <p>Bank: Nykredit 8117 2011462</p>
          </div>
        </div>
        <div class="site-footer__social">
          <a
            v-for="item in socialLinks"
            :key="item.shortName"
            :href="item.link"
            :class="'social-link social-link--' + item.name"
          >{{item.name}}</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Footer",

  props: {
    boring: { type: Boolean, default: false }
  },

  data() {
    return {
      ownPosition: 0,
      ownHeight: 0,
      amountOfFooterInView: 0
    };
  },

  computed: {
    ...mapState({
      currentScroll: state => state.globals.currentScroll,
      screenHeight: state => state.globals.screenHeight,
      screenWidth: state => state.globals.screenWidth,
      contacts: state => state.data.contactsPage,
      socialLinks: state => state.data.socialLinks
    }),
    translateString() {
      return this.boring
        ? ""
        : `transform: translateY(${this.amountOfFooterInView - 100}%);`;
    }
  },

  watch: {
    screenWidth: "getOwnPosition",
    currentScroll: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.getOwnPosition();
          this.rePosition();
        });
      }
    }
  },

  methods: {
    getOwnPosition() {
      this.ownPosition =
        this.$el.getBoundingClientRect().top +
        this.currentScroll -
        this.screenHeight;
      this.ownHeight = window.getComputedStyle(this.$refs.footerContent).height;
    },
    rePosition() {
      if (this.currentScroll >= this.ownPosition) {
        this.moveFooterContent(this.currentScroll);
      } else if (this.currentScroll < this.ownPosition) {
        this.amountOfFooterInView = 0;
      }
    },
    moveFooterContent(scroll) {
      const percent =
        ((scroll - this.ownPosition) / parseInt(this.ownHeight)) * 100;
      const capped = Math.min(percent, 100);

      this.amountOfFooterInView = capped;
    }
  },

  mounted() {
    this.$nextTick(() => this.getOwnPosition());
  }
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.site-footer {
  position: relative;
  overflow: hidden;
  color: $color-white;

  footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;

    @extend %page-margin-2;
    @extend %page-margin-2-v;

    background-color: #252525;
  }

  &__header {
    display: flex;
    flex-wrap: wrap;

    @media screen and (min-width: 768px) {
      padding-bottom: rem(96);
    }
    @media screen and (min-width: 1024px) {
      padding-bottom: rem(192);
    }
  }

  &__title {
    @include typeface(expanded);
    @include typeset(display-3);

    line-height: 1.2;

    width: 100%;
    box-sizing: border-box;
    padding-right: rem(16);
    padding-bottom: rem(16);

    @media screen and (min-width: 768px) {
      @include typeset(display-1);
      width: 66%;
    }
  }

  &__paragraph {
    @include typeset(body-medium);
    color: darken(white, 40%);

    width: 100%;

    @media screen and (min-width: 1024px) {
      width: 33%;
    }
  }

  &__content {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
  }

  &__item {
    @include typeset(body-medium);
    flex-shrink: 0;

    color: darken(white, 20%);
    padding-right: 7.5%;
    width: 100%;
    box-sizing: border-box;

    @media screen and (min-width: 1024px) {
      width: 33%;
    }

    &:last-of-type {
      padding-right: 5%;
    }

    &__title {
      @include typeset(body-normal);
      margin-top: rem(24);
      color: darken(white, 40%);

      @media screen and (min-width: 1024px) {
        margin-bottom: rem(48);
      }
    }
  }

  &__contacts {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    @media screen and (min-width: 768px) {
      width: 66%;
    }
  }

  &__social {
    @include typeset(body-normal);

    display: flex;
    justify-content: space-between;

    color: darken(white, 40%);
    margin-top: rem(48);

    width: 100%;

    @media screen and (min-width: 768px) {
      justify-content: flex-start;
      margin-top: 0;
      width: 33%;
    }

    a {
      @media screen and (min-width: 768px) {
        padding-right: rem(48);
      }
    }
  }
}
</style>
